import React, { useEffect, useState } from "react";

//* Placeholder Assets
import square from "../../assets/images/ad-space-square.jpg";
import carousel from "../../assets/images/ad-space-carousel.jpg";
import skyscraper from "../../assets/images/ad-space-skyscraper.jpg";
import axiosGeneral from "../../utils/axiosGeneral";
import { Carousel } from "antd";

export default function Advertisements(props) {
  const { type } = props;

  const [ad, setAd] = useState([]);
  const [currentAdIndex, setCurrentAdIndex] = useState(0);

  useEffect(() => {
    getAds();
  }, []);

  useEffect(() => {
    if (type === "square" && ad.length > 0) {
      const interval = setInterval(() => {
        const randomIndex = Math.floor(Math.random() * ad.length);
        setCurrentAdIndex(randomIndex);
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [ad, type]);

  const renderAd = (ad) => {
    const adUrl = ad.meta_data.find(
      (meta) => meta.meta_key === "ad_url"
    )?.meta_value;
    const adImage =
      ad.meta_data.find((meta) => meta.meta_key === "ad_image")?.meta_value ||
      "default-image-url.jpg";

    return adUrl ? (
      <a href={adUrl} key={ad.id}>
        <img src={adImage} alt={`${type} Ad`} style={{ width: "100%" }} />
      </a>
    ) : (
      <img
        src={adImage}
        alt={`${type} Ad`}
        style={{ width: "100%" }}
        key={ad.id}
      />
    );
  };

  const getAds = async () => {
    try {
      const response = await axiosGeneral().get(
        `/api/advertisement/getAddsForPublic/${
          type === "square" ? "free" : "pay"
        }`
      );
      setAd(response.data || null);
    } catch (error) {
      console.error("Error getting user ads:", error);
    }
  };

  if (!ad) {
    return null;
  }

  return (
    <div className="advertisement">
      {type === "square" && (
        <>
          {Array.isArray(ad) && ad.length > 0 ? (
            ad[currentAdIndex]?.meta_data.find(
              (meta) => meta.meta_key === "ad_url"
            )?.meta_value ? (
              <a
                href={
                  ad[currentAdIndex]?.meta_data.find(
                    (meta) => meta.meta_key === "ad_url"
                  ).meta_value
                }
              >
                <img
                  src={
                    ad[currentAdIndex]?.meta_data.find(
                      (meta) => meta.meta_key === "ad_image"
                    )?.meta_value || square
                  }
                  alt="Square Ad"
                />
              </a>
            ) : (
              <img
                src={
                  ad[currentAdIndex]?.meta_data.find(
                    (meta) => meta.meta_key === "ad_image"
                  )?.meta_value || square
                }
                alt="Square Ad"
              />
            )
          ) : (
            <img src={square} alt="Ad Placeholder" />
          )}
        </>
      )}

      {type === "skyscraper" && (
        <a href={`/business/${ad.businessHandle}`}>
          <img
            src={
              ad[0].meta_data.find((meta) => meta.meta_key === "ad_image")
                .meta_value
            }
            alt="Skyscraper Ad"
          />
        </a>
      )}

      {type === "carousel" && (
        <Carousel autoplay>
          {Array.isArray(ad) && ad.length > 0 ? (
            ad.map(renderAd)
          ) : (
            <img src={carousel} alt="Ad Placeholder" />
          )}
        </Carousel>
      )}
    </div>
  );
}
